var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9625 60C25.7179 60 21.7728 59.2375 18.1273 57.7125C14.4819 56.1875 11.3109 54.075 8.61423 51.375C5.9176 48.675 3.80774 45.5 2.28464 41.85C0.761548 38.2 0 34.25 0 30C0 25.8 0.761548 21.875 2.28464 18.225C3.80774 14.575 5.9176 11.4 8.61423 8.7C11.3109 6 14.4819 3.875 18.1273 2.325C21.7728 0.775 25.7179 0 29.9625 0C33.7079 0 37.2035 0.6 40.4494 1.8C43.6954 3 46.6167 4.65 49.2135 6.75L45.9925 9.975C43.7953 8.225 41.3483 6.875 38.6517 5.925C35.9551 4.975 33.0587 4.5 29.9625 4.5C22.7216 4.5 16.6667 6.9375 11.7978 11.8125C6.92884 16.6875 4.49438 22.75 4.49438 30C4.49438 37.25 6.92884 43.3125 11.7978 48.1875C16.6667 53.0625 22.7216 55.5 29.9625 55.5C37.2035 55.5 43.2584 53.0625 48.1273 48.1875C52.9963 43.3125 55.4307 37.25 55.4307 30C55.4307 28.5 55.3184 27.0375 55.0936 25.6125C54.8689 24.1875 54.5318 22.8 54.0824 21.45L57.5281 18C58.3271 19.85 58.9263 21.775 59.3258 23.775C59.7253 25.775 59.9251 27.85 59.9251 30C59.9251 34.25 59.1511 38.2 57.603 41.85C56.0549 45.5 53.9326 48.675 51.236 51.375C48.5393 54.075 45.3683 56.1875 41.7228 57.7125C38.0774 59.2375 34.1573 60 29.9625 60ZM25.5431 43.65L13.1835 31.2L16.5543 27.825L25.5431 36.825L56.5543 5.775L60 9.15L25.5431 43.65Z",
    fill: "#3BBA4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.81c2e511d31289494e9f633ce9b408fc.svg";
export { ForwardRef as ReactComponent };